import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  pageContent: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    borderRadius: "10px",
    boxSizing: "border-box",
    paddingBlock: "16px",
    paddingInline: "16px"
  },
  featureitems: {
    display: "flex",
    gap: "0.5rem",
    marginBottom: "8px",
    alignItems: "center"
  },
  planVariant: {
    marginBottom: "8px",
    display: "block",
    fontWeight: "600"
  },
  variants: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "12px",
    backgroundColor: "#f9f9f9"
  },
  variantHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px"
  },
  top_12_pointer: {
    marginTop: "12px",
    cursor: "pointer"
  },
  existingVariant: {
    margin: "0 0 12px 0",
    fontSize: "16px",
    color: "#495057",
    borderBottom: "2px solid #e9ecef",
    paddingBottom: "8px"
  },
  variantId: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "12px",
    backgroundColor: "#f9f9f9"
  },
  underVariantId: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px"
  },
  variantName: {
    margin: 0,
    fontSize: "14px",
    fontWeight: "600"
  },
  variantdEdits: {
    display: "flex",
    gap: "8px",
    alignItems: "center"
  },
  variantSection: {
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: "#f0f8ff",
    borderRadius: "8px",
    border: "2px dashed #1890ff"
  },
  newVariant: {
    margin: "0 0 12px 0",
    fontSize: "16px",
    color: "#1890ff",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  addvariantInfo: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: "#666"
  },
  variantDetailInfo: {
    border: "1px solid #bae7ff",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "12px",
    backgroundColor: "#e6f7ff"
  },
  variantandIcon: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px"
  },
  variantHeadline: {
    margin: 0,
    fontSize: "14px",
    fontWeight: "600",
    color: "#1890ff"
  },
  newVariantBottom: {
    marginTop: "12px",
    cursor: "pointer",
    padding: "12px",
    border: "1px dashed #1890ff",
    borderRadius: "8px",
    textAlign: "center",
    color: "#1890ff",
    fontWeight: "500"
  },
  variantOne: {
    marginTop: "16px",
    padding: "16px",
    backgroundColor: "#f6ffed",
    borderRadius: "8px",
    border: "1px solid #b7eb8f"
  },
  readyVariant: {
    margin: "0 0 8px 0",
    fontSize: "16px",
    color: "#389e0d"
  },
  validVariant: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: "#666"
  },
  deleteVariantHeader: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px"
  },
  strongDetail: {
    color: "#ff6b35",
    fontSize: "14px",
    marginTop: "8px"
  }
}));
